import { render, staticRenderFns } from "./eDSCompLanguage.vue?vue&type=template&id=0af3fc2f"
import script from "./eDSCompLanguage.vue?vue&type=script&lang=js"
export * from "./eDSCompLanguage.vue?vue&type=script&lang=js"
import style0 from "./eDSCompLanguage.vue?vue&type=style&index=0&id=0af3fc2f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports